import React from 'react';
import PropTypes from 'prop-types';

const TextArea = ({
  label,
  id,
  value,
  onChange = () => ({}),
  onBlur = () => ({}),
  required = false,
  dataTest,
  placeholder,
  error,
  disabled = false,
  bottomMarginSizing
}) => {
  return (
    <div
      className={`${
        bottomMarginSizing === 1 ? 'mb-4' : bottomMarginSizing === 0 ? 'mb-0' : 'mb-8'
      }`}
    >
      {label && (
        <label
          htmlFor={id}
          className={`block font-sans text-sm font-bold text-grey-400 ${
            error ? 'text-red-100' : ''
          }`}
        >
          {label}
          {required ? <span className={error ? 'text-red-100' : 'text-blue-100'}>*</span> : null}
        </label>
      )}
      <textarea
        name={id}
        id={id}
        className={`border-2 border-grey-200 bg-white shadow-sm hover:border-grey-300 focus:border-purple-100 block w-full p-2.5 rounded-sm font-sans text-base font-normal mt-1  disabled:bg-grey-100 disabled:border-grey-200 disabled:text-grey-400' ${
          error ? 'border-red-100' : ''
        }`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        data-testid={dataTest}
        disabled={disabled}
        placeholder={placeholder}
      />
      {error ? (
        <small
          data-testid={`${dataTest}-error`}
          className="font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
        >
          {error}
        </small>
      ) : null}
    </div>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  bottomMarginSizing: PropTypes.oneOf([1, 0, undefined]),
  placeholder: PropTypes.string
};

export default TextArea;
